document.addEventListener('DOMContentLoaded', function () {
    const slider = UIkit.slider('.list-items-stock .uk-slider');
    const indicator = document.querySelector('.list-items-stock .slide-indicator');
    if (!slider || !indicator) return;
    const totalSlides = document.querySelectorAll('.list-items-stock .uk-slider-items > div').length;
    const updateIndicator = () => {
        const current = slider.index + 1;
        indicator.textContent = `${current} / ${totalSlides}`;
    };
    updateIndicator();
    slider.$el.addEventListener('beforeitemshow', updateIndicator);
});